// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__OFF-M","footer":"ReportModalFilter_footer__3ENEV"};